// extracted by mini-css-extract-plugin
export var chevron = "_lg-1";
export var clickable = "_lg-0";
export var ruleRow = "_lg-2";